import React from 'react';
export const IconEvisa = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.808",
  height: "17.942",
  viewBox: "0 0 14.808 17.942"
}, /*#__PURE__*/React.createElement("g", {
  id: "document-1-svgrepo-com",
  transform: "translate(-3.25 -1.556)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_7131",
  d: "M4,5.826V16.561a2.513,2.513,0,0,0,2.548,2.477h8.493a2.513,2.513,0,0,0,2.548-2.477V8.3a2.513,2.513,0,0,0-2.548-2.477Zm0,0V5",
  transform: "translate(-0.131 -0.141)",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7132",
  d: "M15.788,5.226v.619h.638V5.226ZM13.848,2.192l-.09-.613ZM4.669,3.466l-.09-.613h0ZM4.8,5.845h10.99V4.606H4.8Zm11.628-.619v-1.4H15.151v1.4ZM13.758,1.579,4.579,2.853l.18,1.226,9.179-1.274ZM4.579,2.853A1.519,1.519,0,0,0,3.25,4.341H4.525a.268.268,0,0,1,.234-.262Zm11.847.974a2.316,2.316,0,0,0-2.668-2.248l.18,1.226a1.053,1.053,0,0,1,1.213,1.022ZM4.8,4.606a.269.269,0,0,1-.273-.265H3.25A1.526,1.526,0,0,0,4.8,5.845Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7133",
  d: "M8,12h6.606",
  transform: "translate(-0.623 -1.585)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "1.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_7134",
  d: "M8,15.5h4.542",
  transform: "translate(-0.669 -2.116)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "1.2"
})));